'use client';

import { useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';

import Button from '@/components/shared/Button/Button';
import { Text } from '@/components/shared/Text/Text';
import { fbAuth } from '@/lib/firebase/init';
import * as Sentry from '@sentry/react';

import styles from './fallback.module.scss';

export default function SentryFallback() {
  const [user] = useAuthState(fbAuth);

  useEffect(() => {
    if (user?.email) {
      Sentry.setUser({
        email: user?.email,
      });
    }
  }, [user?.email]);

  const reset = () => {
    window.location.reload();
  };

  return (
    <div className={styles.error}>
      <div className={styles.error__container}>
        <Text.H2>Something went wrong</Text.H2>
        <Button onClick={() => reset()} label="Try again" />
      </div>
    </div>
  );
}
